var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('side-nav'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticStyle:{"margin":"10px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }